import { type FC } from "react";

import { Colors } from "@snapchat/snap-design-system";
import { Sizes } from "@snapchat/snap-design-system-icons";

interface AssetLibraryIconProps {
    size?: Sizes;
    fill?: string;
}

export const AssetLibraryIcon: FC<AssetLibraryIconProps> = ({ size = Sizes.Medium, fill = Colors.Black.V100 }) => {
    const px = Number(size);

    return (
        <svg width={px} height={px} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.5" y="9.5" width="5" height="5" rx="0.5" stroke={fill} />
            <rect x="1.5" y="1.5" width="5" height="5" rx="0.5" stroke={fill} />
            <rect
                x="8.70711"
                y="4"
                width="4.6569"
                height="4.6569"
                rx="0.5"
                transform="rotate(-45 8.70711 4)"
                stroke={fill}
            />
            <rect x="9.5" y="9.5" width="5" height="5" rx="0.5" stroke={fill} />
        </svg>
    );
};
